var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      style: _vm.showModal ? "" : "display: none;",
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.showModal = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.podcast.audio ? _vm.podcast.audio.title : "") +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding q-px-none" }, [
            _c("div", { staticClass: "row full-width" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-list",
                    { attrs: { "no-border": "" } },
                    _vm._l(_vm.audios, function(audio, index) {
                      return _c(
                        "q-item",
                        {
                          key: index,
                          class: _vm.position === index ? "bg-light" : "",
                          nativeOn: {
                            click: function($event) {
                              return _vm.changeTrack(index)
                            }
                          }
                        },
                        [
                          _c("q-item-main", {
                            attrs: {
                              label: audio.audio.title,
                              "label-lines": "3",
                              sublabel: audio.audio.origin_playlist,
                              "sublabel-lines": "3"
                            }
                          }),
                          _c(
                            "q-item-side",
                            { attrs: { right: "" } },
                            [
                              _c("q-item-tile", { attrs: { stamp: "" } }, [
                                _vm._v(_vm._s(audio.audio.duration) + " ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "q-toolbar",
            {
              staticClass: "bg-white",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "vue-plyr",
                { ref: "plyr", staticClass: "full-width q-pa-md podcast" },
                [_c("audio", { ref: "player", attrs: { playsinline: "" } })]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }